export const JOGGER = 'jogger'
export const INJURED = 'injured'
